import { useRoutes } from "react-router-dom";
import { routes } from "./app/routes";

export default function App() {
  return useRoutes(routes);
}     

/*import { useEffect, useState } from "react"; //Animation
import { useRoutes } from "react-router-dom";
import { routes } from "./app/routes";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";

export default function App() {
  const element = useRoutes(routes);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return element;
}*/